/**
 * Общая логика триала — используется в TrialBanner и в блокировке разделов.
 */

export const getTrialDaysRemaining = (company) => {
  if (!company || company.subscription_status !== 'trial' || !company.trial_ends_at) {
    return null;
  }
  const diffMs = new Date(company.trial_ends_at) - new Date();
  return Math.ceil(diffMs / (1000 * 60 * 60 * 24));
};

export const isTrialExpired = (company) => {
  const days = getTrialDaysRemaining(company);
  return days !== null && days <= 0;
};

const RESTRICTED_STATUSES = ['suspended', 'cancelled', 'frozen'];

/**
 * Есть ли у компании доступ к разделам, кроме Дашборда и Отчётов —
 * false, если триал истёк или подписка не активна (отменена/заморожена/приостановлена).
 */
export const hasCompanyAccess = (company) => {
  if (!company) return true;
  if (RESTRICTED_STATUSES.includes(company.subscription_status)) return false;
  return !isTrialExpired(company);
};
